<template>
  <div>
    <!-- <div v-if="!viewText">
      <partnerSchedule
        :partners="partners"
        :programPartnerSchedules="[programPartnerSchedule]"
        :programs="programs"
        :viewPartner="true"
        :itemsPerPage="10"
        @getPrgPartnerSchedule="getPrgPartnerSchedule"
      />
    </div> -->
    <div class="pt-4" v-if="!viewText || viewText == 'Partner'">
      <div class="ml-4 pl-4">
        <span class="text-5xl font-weight-bold accent--text"> PARTNER </span>
      </div>
      <partnerSchedule
        :partnerId="partnerId"
        :partners="partners"
        :programPartnerSchedules="programPartnerSchedules"
        :programs="programs"
        :viewPartner="true"
        :itemsPerPage="itemsPerPage"
        @viewMore="viewMore"
        @getPrgPartnerSchedule="getPrgPartnerSchedule"
      />
    </div>
  </div>
</template>

<script>
import partnerSchedule from "@/components/link/schedule.vue";

export default {
  components: {
    partnerSchedule,
  },
  data() {
    return {
      programs: [],
      partners: [],
      programPartnerSchedules: [],
      partnerId: null,
      itemsPerPage: 5,
      programPartnerSchedule: {},
      viewText: null,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.partnerId = Number(this.$route.params?.id);
    this.initialise();
  },
  methods: {
    viewMore(value) {
      this.$router.push({
        name: "View Add-on Programme Code",
        params: { id: this.partnerId, code: value },
      });
    },
    async initialise() {
      await Promise.all([
        this.getPartners(),
        this.getPrgPartnerSchedule(),
        this.getPrograms(),
      ]);
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPartners() {
      await this.$axios
        .get(`partners`)
        .then((res) => {
          this.partners = res.data.data;
          const PartnerName = this.partners.find(
            (item) => item.id == this.partnerId
          )?.name;

          const crumbs = [
            {
              text: "Partner Admission Schedule",
              to: { name: "Partner Admission Schedule" },
            },
            {
              text: PartnerName,
              to: {
                name: "View Partner Add-on Programme",
                params: { id: this.partnerId },
              },
            },
          ];
          if (
            this.$route.params?.code &&
            ["Partner"].includes(this.$route.params.code)
          ) {
            this.viewText = this.$route.params.code;
            this.itemsPerPage = -1;
            crumbs.push({ text: this.$route.params.code });
          } else {
            crumbs[crumbs.length - 1].to = undefined;
          }
          this.$store.commit("setBreadcrumbs", crumbs);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrgPartnerSchedule() {
      await this.$axios
        .get("batch_partner_schedules", {
          params: { partner_id: this.partnerId },
        })
        .then((res) => {
          this.programPartnerSchedules = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
